import { ReactNode } from 'react'

import PlainTooltip from 'app/common/ui-next/plain-tooltip'

import styles from './ComplexTooltip.module.scss';

type Props = {
  title: string
  items: Array<string>
  children: ReactNode
}

const ComplexTooltip = ({ title, items, children }: Props) => {
  const content = (
    <div className={styles.root}>
      <div className={styles.header}>{title}</div>
      <ul className={styles.list}>
        {items.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    </div>
  )

  return <PlainTooltip content={content}>{children}</PlainTooltip>
}

export default ComplexTooltip
